







import Header from '@/views/organisms/Header.vue'

export default
  components: {
    Header
  }

